<template>
  <div class="home page">
    <transition name="appear">
      <trip-planner-inputs v-if="pageReady" :isFuture="isFuture"></trip-planner-inputs>
    </transition>

    <trip-planner-results :isFuture="isFuture"></trip-planner-results>

  </div>
</template>

<script>
// @ is an alias to /src
import TripPlannerInputs from '@/components/TripPlannerInputs.vue'
import TripPlannerResults from '@/components/TripPlannerResults.vue'
import mixinCommon from '../mixins/common'

export default {
  name: 'trip-planner',
  components: {
    TripPlannerInputs, TripPlannerResults
  },
  mixins: [mixinCommon],
  data () {
    return {
      isFuture: window.showFutureRoutes || false,
      pageReady: false
    }
  },
  computed: {
    resultsReady () {
      if (this.$route.name === 'trip-planner-inputs-ready-plan' 
          || this.$route.name === 'trip-planner-trip-details') {
        return true
      }
      return false
    }
  },
  mounted () {
    this.pageReady = true
  }
}
</script>
<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/views/TripPlanner.vue